import { FC } from "react";
import { IconPropsType } from ".";

export const Note: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="11"
        height="15"
        rx="2.5"
        stroke={props.color}
      />
      <rect x="3" y="4" width="6" height="1" rx="0.5" fill={props.color} />
      <rect x="3" y="7" width="6" height="1" rx="0.5" fill={props.color} />
      <rect x="6" y="10" width="3" height="1" rx="0.5" fill={props.color} />
    </svg>
  );
};
